import React from 'react';
import PropTypes from 'prop-types';
import { dateFormatLong, dateFormatShort } from '../../utils/strings';
import {
    DATE_FORMATS,
    DATE_FORMAT_DEFAULT,
    DATE_FORMAT_SHORT
} from './constants';

import './DateTimeRange.css';

// Format time to "6:00 PM" style
var formatTime = function(timeStr) {
    if (!timeStr) return null;
    // Handle various time formats
    var match = timeStr.match(/(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM)?/i);
    if (!match) return timeStr;

    var hours = parseInt(match[1], 10);
    var minutes = match[2];
    var ampm = match[4];

    // If no AM/PM provided, assume 24-hour format
    if (!ampm) {
        ampm = hours >= 12 ? 'PM' : 'AM';
        if (hours > 12) hours -= 12;
        if (hours === 0) hours = 12;
    }

    return hours + ':' + minutes + ' ' + ampm.toUpperCase();
};

var DateTimeRange = function(props) {
    var startDate = props.startDate;
    var startTime = props.startTime;
    var endDate = props.endDate;
    var endTime = props.endTime;
    var format = props.format || DATE_FORMAT_DEFAULT;
    var compact = props.compact;
    var countryId = props.countryId;

    // Select formatter based on format, passing countryId for localization
    var formatDate = format === DATE_FORMAT_SHORT ? dateFormatShort : dateFormatLong;

    // For cards (compact), just show end date simply
    if (compact) {
        var formattedDate = formatDate(endDate, countryId);
        var formattedTime = formatTime(endTime);

        return (
            <div className="al-date-display al-date-display--compact">
                <span className="al-date-label">Ends</span>
                <span className="al-date-datetime">
                    <span className="al-date-value">{formattedDate}</span>
                    {formattedTime && <span className="al-date-time"> at {formattedTime}</span>}
                </span>
            </div>
        );
    }

    // Full display - show both start and end
    var startFormatted = formatDate(startDate, countryId);
    var endFormatted = formatDate(endDate, countryId);
    var startTimeFormatted = formatTime(startTime);
    var endTimeFormatted = formatTime(endTime);

    return (
        <div className="al-date-display">
            <div className="al-date-row al-date-row--end">
                <span className="al-date-label">Ends:</span>
                <span className="al-date-value">{endFormatted}</span>
                {endTimeFormatted && <span className="al-date-time">at {endTimeFormatted}</span>}
            </div>
            <div className="al-date-row al-date-row--start">
                <span className="al-date-label">Starts:</span>
                <span className="al-date-value">{startFormatted}</span>
                {startTimeFormatted && <span className="al-date-time">at {startTimeFormatted}</span>}
            </div>
        </div>
    );
};

DateTimeRange.propTypes = {
    startDate: PropTypes.string,
    startTime: PropTypes.string,
    endDate: PropTypes.string,
    endTime: PropTypes.string,
    format: PropTypes.oneOf(DATE_FORMATS),
    compact: PropTypes.bool,
    countryId: PropTypes.number
};

DateTimeRange.defaultProps = {
    format: DATE_FORMAT_DEFAULT,
    compact: false
};

export default DateTimeRange;
